import { getSession } from './session'
import getIsManagerCompany from '@/lib/admin/getIsManagerCompany'
import getIsManagerDelegateCompany from '@/lib/admin/getIsManagerDelegateCompany'
import getIsPharmacy from '@/lib/admin/getIsPharmacy'
import getIsUserAdminSoundBackOffice from '@/lib/admin/getIsUserAdminSoundBackOffice'
import getIsUserIndustrySchool from '@/lib/admin/getIsUserIndustrySchool'
import getIsUserIndustryStore from '@/lib/admin/getIsUserIndustryStore'
import getIsUserStudents from '@/lib/admin/getIsUserStudents'
import getIsUserTeamsPreparateur from '@/lib/admin/getIsUserTeamsPreparateur'
import { CONSTANTS } from '@/types/enum/constants'
import getIsPharmacyManager from '@/lib/admin/getIsPharmacyManager'
import getIsUserAdminInsightBackOffice from '@/lib/admin/getIsUserAdminInsightBackOffice'
import getIsUserAdminSchoolBackOffice from '@/lib/admin/getIsUserAdminSchoolBackOffice'
import getIsUserAdminStoreBackOffice from '@/lib/admin/getIsUserAdminStoreBackOffice'
import getIsUserAdminStoreBagBackOffice from '@/lib/admin/getIsUserAdminStoreBagBackOffice'
import getIsUserBackOffice from '@/lib/admin/getIsUserBackOffice'
import getIsUserIndustryPmiDiy from '@/lib/admin/getIsUserIndustryPmiDiy'
import getIsUserTeams from '@/lib/admin/getIsUserTeams'
import { EntityList } from '@/types/Entity'

export const getRolesUserAndSwitchUser = () => {
  const session = getSession()

  const isAuthentificated = session?.status === 'authenticated'
  const loggedUserRoles = session.switchUserRoles || session.user?.roles || []

  const isUserIndustry =
    getIsUserIndustryPmiDiy(loggedUserRoles) ||
    getIsUserIndustrySchool(loggedUserRoles) ||
    getIsUserIndustryStore(loggedUserRoles)

  //on peut avoir un admin school isUserAdminBackOffice qui n'est pas dans LIST_ROLES_AUTHORIZE_BACK_OFFICE_ADMIN car les routes sont différentes
  //cas pour school be
  const isUserAdminBackOffice = isAuthentificated && getIsUserBackOffice(loggedUserRoles)

  const isUserAdminSoundBackOffice =
    isAuthentificated && getIsUserAdminSoundBackOffice(loggedUserRoles)

  const isPharmacyManager = isAuthentificated && getIsPharmacyManager(loggedUserRoles)

  const isUserAdminInsightBackOffice =
    isAuthentificated && getIsUserAdminInsightBackOffice(loggedUserRoles)

  const isUserAdminSchoolBackOffice =
    isAuthentificated && getIsUserAdminSchoolBackOffice(loggedUserRoles)

  const isUserAdminStoreBagBackOffice =
    isAuthentificated && getIsUserAdminStoreBagBackOffice(loggedUserRoles)
  const isUserAdminStoreBackOffice =
    isAuthentificated && getIsUserAdminStoreBackOffice(loggedUserRoles)

  const isUserStudents = isAuthentificated && getIsUserStudents(loggedUserRoles)
  const isManagerCompany = isAuthentificated && getIsManagerCompany(loggedUserRoles)
  const isManagerDelegateCompanySchool =
    isAuthentificated && getIsManagerDelegateCompany(loggedUserRoles, EntityList.PHARMEDISCHOOL)

  const isManagerDelegateCompanyStore =
    isAuthentificated && getIsManagerDelegateCompany(loggedUserRoles, EntityList.PHARMEDISTORE)

  const isPharmacy = isAuthentificated && getIsPharmacy(loggedUserRoles)
  const isUserTeams = isAuthentificated && getIsUserTeams(loggedUserRoles)

  const isUserIndustryPmiDiy = getIsUserIndustryPmiDiy(loggedUserRoles)
  const isUserIndustrySchool = getIsUserIndustrySchool(loggedUserRoles)
  const isUserIndustryStore = getIsUserIndustryStore(loggedUserRoles)
  const isUserTeamsPreparateur = getIsUserTeamsPreparateur(loggedUserRoles)

  const isUserGroupementManager = loggedUserRoles.includes(CONSTANTS.ROLE_GROUPEMENT_MANAGER)
  const isUserChainManager =
    loggedUserRoles.includes(CONSTANTS.ROLE_CHAIN_MANAGER) ||
    loggedUserRoles.includes(CONSTANTS.ROLE_CHAIN_ZONE_MANAGER)

  const rolesProfile = {
    isAuthentificated,
    loggedUserRoles,
    isUserAdminBackOffice,
    isUserAdminSoundBackOffice,
    isUserAdminSchoolBackOffice,
    isUserAdminStoreBagBackOffice,
    isUserAdminInsightBackOffice,
    isUserAdminStoreBackOffice,
    isUserTeams,
    isUserStudents,
    isPharmacy,
    isUserIndustry,
    isUserIndustryPmiDiy,
    isUserIndustrySchool,
    isUserIndustryStore,
    isUserTeamsPreparateur,
    isManagerCompany,
    isManagerDelegateCompanySchool,
    isManagerDelegateCompanyStore,
    isUserGroupementManager,
    isUserChainManager,
    isPharmacyManager,
  }

  return {
    isAuthentificated,
    loggedUserRoles,
    userId: session?.user?.id,
    rolesProfile,
  }
}
